import {Component} from 'react';
import axios from "axios"
import Swal from "sweetalert2";
import Chart from "react-apexcharts";
import myconfig from "../../myconfig";
import $ from 'jquery';

let source = axios.CancelToken.source();

class Public_dashboard extends Component {
    constructor() {
        super();
        this.state = {
            wiz: 0,
            status: [],
            vehicles: [],
            vehicles_fitler: [],
            series: [],
            sum_datas: [],
            datas: [],
            det_datas: [],
            options: {}
        }
    }
    componentDidMount() {
        this.fetchdata()
    }
    fetchdata = () => {
        let baseurl = myconfig.pub_dashboard_1;
        let token = new URLSearchParams(this.props.location.search).get("token");
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            token: token,
        }, {cancelToken: source.token}).then(res => {
            if (!res.data.auth) {
                this.setState({
                    wiz:1,
                })
            } else if (!res.data.success) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    wiz:2,
                    status:res.data.status,
                    vehicles:res.data.vehicles,
                    series: res.data.series,
                    sum_datas: res.data.sum_datas,
                    datas: res.data.datas,
                    options: {
                        chart: {
                            width: 350,
                            type: 'pie',
                        },
                        legend: {
                            position: 'bottom',
                            show: true,
                        },
                        labels: res.data.lables,
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200
                                },
                            }
                        }]
                    },
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    more_status = (event,ty) => {
        event.preventDefault();
        let temp = this.state.vehicles;
        if (ty != "All") {
            temp = this.state.vehicles.filter(v => {
                if (v.status == ty)
                    return v;
            })
        }
        this.setState({
            vehicles_fitler: temp
        })
    }
    more_datas = (event,ty,value) => {
        event.preventDefault();
        let temp = [];
        if (value == "0") {
            temp = this.state.datas.filter(v => {
                if (v.status == ty)
                    return v;
            })
        }
        else
        {
            temp = this.state.datas.filter(v => {
                if (v.status == ty && v.type==value)
                    return v;
            })
        }
        this.setState({
            det_datas: temp
        })
    }

    wiz_0=()=> {
        return (
            <div className="card-body" style={{minHeight: "100vh"}}>
                <h5>Loading...</h5>
            </div>
        )
    }
    wiz_1=()=> {
        return (
            <div className="card-body" style={{minHeight: "100vh"}}>
                <h5>Invalid session token. Please contact your admin.</h5>
            </div>
        )
    }
    wiz_2=()=> {
        let t_data_status_sum=this.state.status.map(v=>{
            return (<tr>
                <td>{v.type}</td>
                <td><a href="" onClick={event => this.more_status(event,v.type)}>{v.count}</a> </td>
            </tr>)
        })
        let t_data_status_det=this.state.vehicles_fitler.map(v=>{
            return (<tr>
                <td>{v.plate_no}</td>
                <td>{v.status}</td>
            </tr>)
        })
        let t_data_sum_datas_sum=this.state.sum_datas.map(v=>{
            return (<tr>
                <td>{v.status}</td>
                <td><a href="" onClick={event => this.more_datas(event,v.status,1)}>{v.oneday}</a></td>
                <td><a href="" onClick={event => this.more_datas(event,v.status,2)}>{v.belowfiveday}</a></td>
                <td><a href="" onClick={event => this.more_datas(event,v.status,3)}>{v.abovefiveday}</a></td>
                <td><a href="" onClick={event => this.more_datas(event,v.status,0)}>{v.total}</a></td>
            </tr>)
        })
        let t_data_sum_datas_det=this.state.det_datas.map(v=>{
            return (<tr>
                <td>{v.plate_no}</td>
                <td>{v.status}</td>
                <td>{v.t}</td>
                <td>{v.dif_con}</td>
            </tr>)
        })

        return (
            <div className="card-body" style={{minHeight: "100vh"}}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">Vehicles Status Pi Chart </h3>
                            </div>
                            <div className="card-body table-responsive p-0" style={{height: '350px'}}>
                                <div id="chart">
                                    <Chart options={this.state.options} series={this.state.series} type="pie" width={350} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">Vehicles Status Summary</h3>
                            </div>
                            <div className="card-body table-responsive p-0" style={{height: '350px'}}>
                                <table className="table table-head-fixed">
                                    <thead>
                                    <tr>
                                        <th className="col-md-6">Status</th>
                                        <th className="col-md-5">Count</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {t_data_status_sum}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">Vehicles Status Detail</h3>
                            </div>
                            <div className="card-body table-responsive p-0" style={{height: '350px'}}>
                                <table className="table table-head-fixed">
                                    <thead>
                                    <tr>
                                        <th className="col-md-6">Plate #</th>
                                        <th className="col-md-5">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {t_data_status_det}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card card-warning">
                            <div className="card-header">
                                <h3 className="card-title">Vehicle Stoppage Summary</h3>
                            </div>
                            <div className="card-body table-responsive p-0" style={{height: '350px'}}>
                                <table className="table table-head-fixed">
                                    <thead>
                                    <tr>
                                        <th className="col-md-4">Status</th>
                                        <th className="col-md-2">For One Day</th>
                                        <th className="col-md-2">Below Five Day</th>
                                        <th className="col-md-2">Above Five Day</th>
                                        <th className="col-md-2">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {t_data_sum_datas_sum}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card card-warning">
                            <div className="card-header">
                                <h3 className="card-title">Vehicle Stoppage Detail</h3>
                            </div>
                            <div className="card-body table-responsive p-0" style={{height: '350px'}}>
                                <table className="table table-head-fixed">
                                    <thead>
                                    <tr>
                                        <th className="col-md-3">Plate #</th>
                                        <th className="col-md-3">Status</th>
                                        <th className="col-md-3">Time</th>
                                        <th className="col-md-3">Stoppage</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {t_data_sum_datas_det}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        let dis=null;
        if(this.state.wiz===0)
            dis=this.wiz_0();
        else if(this.state.wiz===1)
            dis=this.wiz_1();
        else if(this.state.wiz===2)
            dis=this.wiz_2();
        return (
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-12 m-2" style={{width: "100%"}}>
                            <div className="card">
                                <div className="card-header bg-green">
                                    <h2 className="card-title">Dashboard</h2>
                                    <div className="card-tools">
                                    </div>
                                </div>
                                {dis}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Public_dashboard;
